import '@fontsource/press-start-2p/latin-400.css';
import '@fontsource/press-start-2p/latin-ext-400.css';
import App from './App.svelte';
import './styles.css';
import { mount } from 'svelte';

mount(App, { target: document.getElementById('app')! });
